<ion-chip class="active" *ngIf="status === 'ACTIVE'">Activa</ion-chip>
<ion-chip class="inactive" *ngIf="status === 'INACTIVE'">Inactiva</ion-chip>
<ion-chip class="emission" *ngIf="status === 'EMISSION'">Contratada</ion-chip>